import { ChangeAvatarRequest, PatientControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useChangePatientAvatar = () =>
  useMutationWithLoading(
    async (param: { xTENANTID: string; avatar: ChangeAvatarRequest }) =>
      new PatientControllerApi(getConfigObject()).changeAvatar2(
        param.avatar,
        param.xTENANTID
      )
  );
